export default __webpack_public_path__ + "static/media/recipient.b66148a9.svg";